export default __webpack_public_path__ + "static/media/section8-img1-deprecated.fdc376c0.png";